import { socketService } from './socketService';
import { socketEventTypes } from '../constants';
import { featureFlagsService } from '../featureFlagsService';
import type { SerializableRemoteObject } from 'clickim/src/background/stepActions/remoteStepActionMixin';

const { REMOTE_STEP_SAVED } = socketEventTypes;

let remoteStepServiceSocketIO: typeof import('./remoteStepServiceSocketIO')['remoteStepServiceSocketIO']; // required lazily since it takes 150ms to load

class RemoteStepService {
    async init(projectId: string) {
        if (featureFlagsService.flags.useNewWSCLI.isEnabled()) {
            return;
        }
        remoteStepServiceSocketIO = (await import('./remoteStepServiceSocketIO')).remoteStepServiceSocketIO;
        remoteStepServiceSocketIO.init(projectId);
    }

    joinToRemoteStep(resultId: string) {
        if (featureFlagsService.flags.useNewWSCLI.isEnabled()) {
            return socketService.addFilter(`${resultId}:remoteStep`, { resultId }, [REMOTE_STEP_SAVED]);
        }
        return remoteStepServiceSocketIO.joinToRemoteStep(resultId);
    }

    listenToRemoteStep(resultId: string, onRemoteStep: (step: SerializableRemoteObject) => void) {
        if (featureFlagsService.flags.useNewWSCLI.isEnabled()) {
            socketService.listenTo(
                `${resultId}:remoteStep`,
                [REMOTE_STEP_SAVED],
                (data: { resultId: string; stepId: string; remoteStep: SerializableRemoteObject }) => data.resultId === resultId && data.remoteStep && data.remoteStep.status === 'pending',
                (data: { resultId: string; stepId: string; remoteStep: SerializableRemoteObject }) => onRemoteStep(data.remoteStep),
            );
            return;
        }
        remoteStepServiceSocketIO.listenToRemoteStep(resultId, onRemoteStep);
    }

    unlistenToRemoteStep(resultId: string) {
        if (featureFlagsService.flags.useNewWSCLI.isEnabled()) {
            socketService.removeFilter(`${resultId}:remoteStep`, [REMOTE_STEP_SAVED]);
            return Promise.resolve();
        }
        return remoteStepServiceSocketIO.unlistenToRemoteStep(resultId);
    }
}

export const remoteStepService = new RemoteStepService();
